import { useRef } from "react";
import { useForm } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import PropTypes from "prop-types";
import AppInput from "@/components/form/input-field";
import TextAreaInputField from "@/components/form/text-area";
import PrimaryBtn from "@/components/button/primaryBtn";
import ContactSubmitSuccessModal from "@/components/modal/ContactSubmitSuccess";
import { contactSchema } from "@/utils/validation/schema/contact";
import { usePostContactUs } from "repo/contactUs";
import getGRecaptchaToken from "@/services/googleReCaptcha";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

function ContactUsForm() {
  const contactSuccessModalRef = useRef();
  const { executeRecaptcha } = useGoogleReCaptcha();

  const { isLoading: isContractSubmitLoading, mutate: submitContact } =
    usePostContactUs({
      onSuccess: () => {
        contactSuccessModalRef.current.click();
        reset();
      },
      onError: (errorData) => {
        errorData.data?.errors.forEach(({ name, message }) => {
          setError(name, { message });
        });
      },
    });

  const {
    register,
    reset,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
    resolver: yupResolver(contactSchema),
  });

  const onSubmitContactForm = async (data) => {
    const contractPayload = {
      ...data,
      gRecaptchaToken: await getGRecaptchaToken(executeRecaptcha, "contract"),
    };
    submitContact(contractPayload);
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmitContactForm)}>
        <div className="w-full rounded-t-[0.75rem] py-[1.25rem]">
          <h3 className="text-[1.5rem] font-semibold ">Leave a message</h3>
        </div>
        <div className="space-y-[1.5rem] py-[1.5rem]">
          <AppInput
            labelName="Full Name"
            isFieldRequired
            placeholder="Enter your full name"
            name="name"
            register={register}
            error={errors.name}
          />
          <AppInput
            labelName="Email"
            isFieldRequired
            placeholder="Enter email address"
            name="email"
            register={register}
            error={errors.email}
          />
          <AppInput
            labelName="Title"
            isFieldRequired
            placeholder="Enter title"
            name="title"
            register={register}
            error={errors.title}
          />
          <TextAreaInputField
            labelName="Message"
            isFieldRequired
            placeholder="Write here"
            name="message"
            register={register}
            error={errors.message}
          />
        </div>
        <div className="flex justify-end space-y-[1.5rem] px-[1.25rem] ">
          <PrimaryBtn
            isLoading={isContractSubmitLoading}
            btnText="Send Message"
            className="w-full py-[.875rem] md:w-[14.625rem] md:py-[1rem]"
          />
        </div>

        <label
          htmlFor="contactSuccessModal"
          className="hidden cursor-pointer rounded-md bg-primary px-4 py-2 text-white"
          ref={contactSuccessModalRef}
        >
          modalOpen
        </label>
      </form>

      <ContactSubmitSuccessModal modalId="contactSuccessModal" />
    </div>
  );
}

export default ContactUsForm;

ContactUsForm.propTypes = {
  headerText: PropTypes.string,
};
